module.exports = __webpack_public_path__ + "img/download02.3b951363.png";